export default "__VITE_ASSET__BfcWkyHz__"